/**
 * Footer's left slot — published-item count + widget quota usage. Shared
 * between the widget index pages (Calendars, Alerts) — `itemLabel`
 * ("calendar"/"alert") drives the pluralized copy; the quota itself is
 * always the org-wide widgets quota (counts every widget type, not just
 * this page's item type), which is why the published-item count is a
 * distinct, separately-tracked number.
 */
import React from "react";
import { Link } from "react-router-dom";
import { QUOTAS, UsageFieldsMapping } from "../../../../consts";
import { hasSubscription } from "../../helpers/organization";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./Footer.module.scss";

const QuotaSummary = ({ currentOrganization, itemLabel, publishedCount }) => {
  const subscription = hasSubscription(currentOrganization);

  if (!subscription || !subscription.quotas) {
    return null;
  }

  const usage = Number(
    currentOrganization.model.usage?.[UsageFieldsMapping[QUOTAS.widgets]] || 0
  );
  const quota = Number(subscription.quotas[QUOTAS.widgets]);
  const unlimited = quota === -1;
  const atLimit = !unlimited && usage >= quota;

  const publishedLabel = `${publishedCount} ${
    publishedCount === 1 ? itemLabel : itemLabel + "s"
  } published.`;

  return (
    <div className={styles.quota}>
      <span className={styles.quotaText}>
        {publishedLabel}{" "}
        {atLimit && <Icon name="AlertTriangle" className={styles.warningIcon} />}
        {atLimit ? (
          <>
            <span className={styles.warningBadge}>
              {usage} of {quota}
            </span>{" "}
            widgets in use. Publishing needs a free slot.
          </>
        ) : unlimited ? (
          "Unlimited widgets in use."
        ) : (
          `${usage} of ${quota} widgets in use.`
        )}
      </span>
      <Link to="/billing" className={styles.managePlan}>
        Manage plan
      </Link>
    </div>
  );
};

export default QuotaSummary;
